/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const userListItemSchema = z.object({
  id: z.optional(z.string()),
  email: z.optional(z.string()),
  name: z.string().nullish(),
  role: z.optional(z.string()),
  isActive: z.optional(z.boolean()),
  createdAt: z.optional(z.iso.datetime()),
  lastLoginAt: z.iso.datetime().nullish(),
});
